import script from "./RadioButtonToolTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./RadioButtonToolTip.vue?vue&type=script&lang=ts&setup=true"

import "./RadioButtonToolTip.vue?vue&type=style&index=0&id=71861f48&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71861f48"]])

export default __exports__